import { MiniappTopbarMenu } from './MiniappTopbarMenu'
import { TopbarProps } from '@/features/topbar/components/topbar/Topbar'
import { assets } from '@/ui/assets'
import { InternalLink } from '@/ui/atoms/link/Link'
import { cn } from '@/ui/utils/style'

export function MiniappTopbar({ menuInfo }: TopbarProps) {
  return (
    <nav className="flex h-100% items-center justify-between gap-2">
      <InternalLink
        to="/"
        variant="decorator"
        className={cn(
          'rounded-md bg-primary/80 px-3 py-2 backdrop-blur-md',
          'focus-visible:bg-primary focus-visible:ring-3',
          'focus-visible:outline-hidden focus-visible:ring-primary-200 focus-visible:ring-offset-0',
        )}
      >
        <img src={assets.brand.logoGradientDark} alt="Spark logo" className="mt-0.5 h-5" />
      </InternalLink>

      <div className="flex flex-nowrap justify-end gap-2 rounded-md bg-primary/60 p-2 backdrop-blur-l">
        <MiniappTopbarMenu {...menuInfo} />
      </div>
    </nav>
  )
}
